'use client';

import type { FC } from 'react';
import Dialog from '@/ui/components/Dialog/Dialog';
import LanguageChangerForm from '@/ui/components/LanguageChanger/LanguageChangerForm';

import $ from './LanguageChanger.module.scss';

interface LanguageChangerModalProps {
  onClose: () => void;
}

const LanguageChangerModal: FC<LanguageChangerModalProps> = ({ onClose }) => (
  <Dialog onClose={onClose} withCancelButton withHeader variant="modal">
    <div className={$.content}>
      <LanguageChangerForm onSubmit={onClose} />
    </div>
  </Dialog>
);

export default LanguageChangerModal;
